import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  addOneItem,
  getBranchList,
  getClassesFilter,
  getDashboardClasses,
  getDeliveryModes,
  getTestTypeList,
  removeOneItem,
} from "../testPrepDashboard/Api/DashboardApi";
import GlobalCard from "../../components/GlobalCardComponent";
import CustomPafinationComp from "./CustomPafinationComp";
import CustomSelect from "../../components/customFields/CustomSelect";
import Loader from "../../../SAPPages/components/Loader/Loader";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import NoclassesScreen from "./NoclassesScreen";
import ArticleIcon from '@mui/icons-material/Article';

import { useDispatch, useSelector } from "react-redux";
import { ADD_TO_WISHLIST, TOGGLE_WISHLIST } from "../../../actions";

import CustomPopup from "../../components/customPopup/CustomPopup";
import BookDemo from "./BookDemoForm";
import ConfimationPopup from "../../components/customPopup/ConfimationPopup";
import GlobalMessageModal from "../../components/customPopup/GlobalMessageModal";
import { useLocation, useNavigate } from "react-router-dom";
import DisableBlueSmallButton from "../../components/customButtons/DisableSmallBlueButton";
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { useSnackbar } from "../../components/snackbars/SnackbarContext";
export default function AllTestPrepClasses() {
  const location = useLocation();
  const { testTypeId } = location.state || [];
  const navigate = useNavigate()

  const [cardData, setCardData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [originalPagination, setOriginalPagination] = useState(null);
  const userId = localStorage.getItem("userId");
  const dispatch = useDispatch();
  const wishlistItems = useSelector((state) => state.wishlist.items);

  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState(null);
  const [page, setPage] = useState(1);
  const [testTypeList, setTestTypeList] = useState([]);
  const [testType, setTestType] = useState(
    testTypeId !== undefined ? [testTypeId] : []
  );
  const [modesList, setModeList] = useState([]);
  const [mode, setMode] = useState([]);
  const [modeName, setModeName] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [branch, setBranch] = useState([]);
  const [bookmarked, setBookmarked] = useState({}); // object to track multiple items
  const [openBookDemo, setOpenBookDemo] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [openSuccesPopup, setOpenSuccesPopup] = useState(false);

  const { showSnackbar } = useSnackbar();



  useEffect(() => {
    const fetTestTypes = async () => {
      try {
        const data = await getTestTypeList();
        setTestTypeList(data);
      } catch (err) {
        console.error("Could not fetch test types");
      } finally {
        console.error("Could not fetch test types");
      }
    };

    fetTestTypes();
  }, []);

  useEffect(() => {
    const fetDeliveryMode = async () => {
      try {
        const data = await getDeliveryModes();
        setModeList(data);
      } catch (err) {
        console.error("Could not fetch delivery mode");
      } finally {
        console.error("Could not fetch delivery mode");
      }
    };

    fetDeliveryMode();
  }, []);

  useEffect(() => {
    const fetchBranch = async () => {
      try {
        const data = await getBranchList();
        setBranchList(data?.data);
      } catch (err) {
        console.error("Could not fetch branches");
      } finally {
        console.error("Could not fetch branches");
      }
    };

    fetchBranch();
  }, []);

  const isFilterApplied = () => {
    return testType.length > 0 || mode.length > 0 || branch.length > 0;
  };

  // fetch class default  data and class Filter
  useEffect(() => {
    setPage(1);
    const modeObject = modesList.filter((i) => mode.includes(i?.id));
    const modename = modeObject?.map((i) => i.name);
    setModeName(modename);
  }, [testType, mode, branch]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
         // ✅ Dynamically decide limit based on screen width
      let limit = 9; // default
      const screenWidth = window.innerWidth;

      if (screenWidth < 600) limit = 4;        // mobile
      else if (screenWidth < 1900) limit = 9;  // medium
        else if (screenWidth > 1900) limit = 12;  // big screen
      else limit = 9;                         
        if (isFilterApplied()) {
          const response = await getClassesFilter({
            limit: limit,
            page,
            test_type_id: testType,
            branch_id: branch,
            class_delivery_mode_id: mode,
            user_id: parseInt(userId)
          });

          setCardData(response.data || []);
          setPagination(response?.pagination);
          // update UI state (mark as bookmarked)
        } else {
          const response = await getDashboardClasses({
            sp_user_id: parseInt(userId),
            limit: limit,
            page,
          });

          setCardData(response.data || []);
          setPagination(response?.pagination);
          setOriginalData(response.data || []);
          setOriginalPagination(response?.pagination);
          // update UI state (mark as bookmarked)
        }
      } catch (error) {
        console.error("Error fetching classes:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [page, testType, mode, branch]);

  // reset filter

  const handleReset = () => {
    setTestType([]);
    setMode([]);
    setBranch([]);
    setPagination(originalPagination);
    setCardData(originalData);
    setPage(1);

  };

  // ✅ Toggle function
  const handleToggleData = async (data) => {
    try {
      const payload = {
        service_id: 1,
        class_id: data?.id,
        user_id: parseInt(userId),
      };

      const isAlreadyBookmarked = wishlistItems.some((w) => w.id === data.id);

      // ✅ choose API dynamically
      const apiCall = isAlreadyBookmarked
        ? removeOneItem({ ...payload, is_adding: false })
        : addOneItem({ ...payload, is_adding: true });

      const response = await apiCall;

      // ✅ response handling in one place
      if (response.status === 200) {
        showSnackbar(response.message, "success");
        // ✅ update redux

        dispatch({
          type: TOGGLE_WISHLIST,
          payload: data, // 👈 full object from API
        });

        // ✅ update UI state instantly
        setBookmarked((prev) => ({
          ...prev,
          [data.id]: !isAlreadyBookmarked,
        }));
      } else if ([400, 401, 500].includes(response.status)) {
        showSnackbar(response.message || "Something went wrong", "error");
      }
    } catch (error) {
      console.error("Toggle error:", error);
      showSnackbar("An error occurred while updating wishlist", "error");
    }
  };

  // select default bookmark items
  useEffect(() => {
    if (cardData.length) {
      const bookmarkedMap = cardData.reduce((acc, item) => {
        acc[item.id] = wishlistItems.some((w) => w.id === item.id);
        return acc;
      }, {});
      setBookmarked(bookmarkedMap);
    }
  }, [wishlistItems, cardData]);

  // Book Demo
  const handleOpenBookDemo = (data) => {
    setOpenBookDemo(true);
    setSelectedData(data);
  };

  const handleCloseBookDemo = () => {
    setOpenBookDemo(false);
  };

  const handleOpenSuccessPopup = () => setOpenSuccesPopup(true);
  const handleCloseSuccessPopup = () => setOpenSuccesPopup(false);



  const handleNavigateToClass = (classData) => {
    navigate('/test-prep/packages', {
      state: { classData },
    });
  };

  const disabledResetButton = testType?.length===0 && modeName?.length===0 && branch?.length===0
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={3}>
          <Typography
            fontSize="24px"
            color="#333333"
            sx={{ fontWeight: 400, fontFamily: "Inter" }}
          >
            Ongoing Batches
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={9}
          container
          justifyContent="end"
          alignItems="center"
          gap={1}
        >
          <CustomSelect
            multiple
            label="All Test Type"
            options={testTypeList}
            value={testType}
            getOptionLabel={(opt) => opt.name}
            getOptionValue={(opt) => opt.id}
            onChange={(e) => setTestType(e.target.value)}
          />

          {/* Modes */}
          <CustomSelect
            multiple
            label="All Modes"
            options={modesList}
            value={mode}
            onChange={(e) => setMode(e.target.value)}
            getOptionLabel={(opt) => opt.name}
            getOptionValue={(opt) => opt.id}
          />

          {/* Branches */}
          {(modeName.includes("offline") || modeName.length === 0) && (
            <CustomSelect
              multiple
              label="All Branches"
              options={branchList}
              value={branch}
              onChange={(e) => setBranch(e.target.value)}
              getOptionLabel={(opt) => opt.branch_name}
              getOptionValue={(opt) => opt.id}
            />
          )}


          <Button
            size="small"
            onClick={handleReset}
            disabled={disabledResetButton}
            sx={{
              background: disabledResetButton?"rgba(0, 0, 0, 0.12)" : "#9D0385",
              color: disabledResetButton ? "rgba(0, 0, 0, 0.26)" : "#ffffff",
              fontWeight: 700,
              fontFamily: "Inter",
              px: 1,
              py: 1,
              height: 34,
              width: 79,
           
              borderRadius: "6px",
              "&:hover": { bgcolor: "#9D0385" },
            }}
          >
            Reset
          </Button>
        
        </Grid>

        <Grid item xs={12}>
          {loading ? (
            <Loader text="Loading Classes..." />
          ) : cardData.length > 0 ? (
            <Grid container spacing={4}>
              {cardData?.map((data, index) => (
                <Grid item xs={12} sm={12} md={4} xl={3}>
                  <GlobalCard key={data.id || index} height="100%">
                    <Box>
                      <Grid container spacing={1}>
                        <Grid item xs={12} position="relative">
                          <Box
                            right={5}
                            top={7}
                            style={{ zIndex: 3, position: "absolute" }}
                          >
                            <IconButton
                              onClick={() => handleToggleData(data)}
                              sx={{
                                width: 36,
                                height: 36,
                                position: "absolute",
                                top: 8,
                                right: 8,
                                backgroundColor: "rgba(255, 255, 255, 0.3)", // semi-transparent white
                                borderRadius: "50%",
                                boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
                                backdropFilter: "blur(4px)", // optional: glass effect
                                zIndex: 2,
                                "&:hover": {
                                  backgroundColor: "rgba(255, 255, 255, 0.4)",
                                },
                              }}
                            >
                              {bookmarked[data?.id] ? (
                                <FavoriteIcon style={{ color: "#572575" }} />
                              ) : (
                                <FavoriteBorderIcon
                                  style={{ color: "#572575" }}
                                />
                              )}
                            </IconButton>
                          </Box>
                          <Box
                            sx={{
                              width: "100",
                              height: "100%",

                              overflow: "hidden",
                              zIndex: 1,
                            }}
                          >
                            <img
                              src={data?.image_path?.image_src}
                              alt="IELTS Coaching"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                display: "block",
                              }}
                            />
                          </Box>
                        </Grid>

                        <Grid item xs={12}>
                          <Grid container>
                            <Grid item xs={6}>
                              <Typography
                                fontSize="20px"
                                color="#9D0385"
                                fontFamily="Inter"
                                fontWeight={400}
                              >
                                {data?.test_type_id?.name}
                              </Typography>
                            </Grid>
                            <Grid
                                                             item
                                                             xs={6}
                                                             container
                                                             alignItems="center"
                                                             justifyContent="end"
                                                             gap={1}
                                                           >
                                                             <Box
                                                               sx={{
                                                                 background:data?.mode_of_delivery==="offline"? "#FFF5DF" :"#96FF6666",
                                                                 py: "5px",
                                                                 px: "7px",
                                                                 display: "flex",
                                                                 alignItems: "center",
                                                                 gap: 1,
                                                                 borderRadius: "10px",
                                                               }}
                                                             >
                                                               <Box
                                                                 sx={{
                                                                   width: "8px",
                                                                   height: "8px",
                                                                   backgroundColor:data?.mode_of_delivery==="offline" ?"#A28000" :"#32860B",
                                                                   borderRadius: "50%",
                                                                 }}
                                                               />
                                                               <Typography
                                                                 fontSize="12px"
                                                                 color={data?.mode_of_delivery==="offline" ?"#6E5906" : "#32860B"} 
                                                                 fontFamily="Inter"
                                                                 fontWeight={400}
                                                               >
                                                                 {data?.mode_of_delivery
                                                                   ? data.mode_of_delivery
                                                                       .charAt(0)
                                                                       .toUpperCase() +
                                                                     data.mode_of_delivery.slice(1)
                                                                   : ""}
                                                               </Typography>
                                                             </Box>
                                                           </Grid>
                          </Grid>
                        </Grid>

                        <Grid
                          item
                          xs={12}
                          container
                          justifyContent="space-between"
                        >
                          {data?.mode_of_delivery === "offline" ? (
                            <Box display="flex" alignItems="center">
                              <Box height={20} width={20} mr={0.5}>
                                <img src="/newdashboard/Classes/mingcute_location-3-line (2).png" />
                              </Box>

                              <Typography
                                sx={{
                                  color: "#000000",
                                  fontSize: 14,
                                  fontWeight: 500,
                                  fontFamily: "Inter",
                                }}
                              >
                                {data?.branch_id?.branch_name}
                              </Typography>
                            </Box>
                          ) : (
                            <Box display="flex" alignItems="center">
                              <Box height={17} width={17} mr={0.5}>
                                <img src="/newdashboard/Classes/proicons_globe.png" />
                              </Box>

                              <Typography
                                sx={{
                                  color: "#000000",
                                  fontSize: 14,
                                  fontWeight: 500,
                                  fontFamily: "Inter",
                                }}
                              >
                                Online Class
                              </Typography>
                            </Box>
                          )}

                          <Box display="flex" alignItems="center">
                            <Box height={20} width={20} mr={0.5}>
                              <img src="/newdashboard/Classes/mingcute_time-line (2).png " />
                            </Box>

                            <Typography
                              sx={{
                                color: "#000000",
                                fontSize: 14,
                                fontWeight: 500,
                                fontFamily: "Inter",
                              }}
                            >
                              {data?.start_time} -{data?.end_time}
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid item xs={12} textAlign="start">
                          <Box display="flex" alignItems="center">
                            <Box height={20.5} width={20.67} mr={0.5}>
                              <img src="/newdashboard/Classes/Frame (2).png" />
                            </Box>


                            <Typography
                              sx={{
                                color: "#000000",
                                fontSize: 14,
                                fontWeight: 500,
                                fontFamily: "Inter",
                              }}
                            >
                              {data?.day?.map(day => day).join(", ")}
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>

                    {/* 👇 Button pinned at the bottom */}
                    <Box
                      mt="auto"
                      textAlign="center"
                      pt={2}
                      display="flex"
                      flexDirection="column"
                      gap={1}
                    >
                      {/* <Button
                        variant="contained"
                        onClick={() => handleOpenBookDemo(data)}
                        style={{
                          background: "#9D03851A",
                          color: "#9D0385",
                          fontWeight: "400",
                          borderRadius: "24px",
                          fontSize: "16px",
                          paddingLeft: 20,
                          paddingRight: 20,
                          fontFamily: "Inter",
                          height: "32px",
                          width: "100%",
                          "&:hover": {
                            textDecoration: "none",
                          },
                        }}
                      >
                        Book Demo
                      </Button> */}
                      <Button
                        variant="contained"
                        onClick={() => handleNavigateToClass(data)}
                        style={{
                          background: "#572575",
                          fontWeight: "500",
                          borderRadius: "8px",
                          fontSize: "16px",
                          paddingLeft: 20,
                          paddingRight: 20,
                          fontFamily: "Inter",
                          height: "32px",
                          width: "100%",
                          "&:hover": {
                            textDecoration: "none",
                          },
                        }}
                      >
                        Enroll Now
                      </Button>
                    </Box>
                  </GlobalCard>
                </Grid>
              ))}
            </Grid>
          ) : (
            <NoclassesScreen />
          )}
        </Grid>

        <Grid item xs={12} mt={2}>
          {pagination && (
            <CustomPafinationComp
              currentPage={pagination?.current_page}
              totalPages={pagination?.total_page}
              onPageChange={setPage}
            />
          )}
        </Grid>
      </Grid>


      <CustomPopup
        handleClose={handleCloseBookDemo}
        component={
          <BookDemo
            handleClose={handleCloseBookDemo}
            selectedData={selectedData}
            handleOpenSuccessPopup={handleOpenSuccessPopup}
          />
        }
        open={openBookDemo}
        title="Book a demo session"
        titleColor="#000000"
        maxWidth="md"
        titleAlign="center"
      />

      <ConfimationPopup
        handleClose={handleCloseSuccessPopup}
        component={
          <GlobalMessageModal
            handleClose={handleCloseSuccessPopup}
            const
            text="Demo Session Booked !."
            subText="Your demo session has been booked. We’ve reserved your slot and shared the details with you."
            buttonTitle="View Demo"
            startIcon={<ArticleIcon />}
            navigateLink="/test-prep/demos"
          />
        }
        open={openSuccesPopup}
        subtitle=""
        maxWidth="sm"
      />
    </>
  );
}
